<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-8">
            <h4 class="fw-bold">Turnover / Revenue - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-4 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />
      <form name="Sharecapital" [formGroup]="Turnoverrevenue">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
          <div class="row">
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">Turnover / Revenue</h5>-->
              <div class="mb-3">
                <p class="mt-4">Please enter notes on turnover, with any relevant analysis by class of business.</p>
                <p>If you do not have any notes to make, please return to the notes menu and de-select this section.</p>

              </div>
            </div>
            <div class="col-12 text-end">
              <button type="button" class="btn themedefault p-1 ps-2 pe-2 me-0" (click)="Addnewrow()" [disabled]="disableTurnover">+ Add New</button>
            </div>
            <div formArrayName="Wizardrows">
              <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-sm-12 col-md-12">
                <div class="row">
                  <div class="table-responsive">
                    <table class="tableheading table dataTable table-bordered table-striped row-border table-hover pt-10" style="white-space:nowrap !important">
                      <thead>
                        <tr>
                          <th>Item Description</th>
                          <th>{{commonService.StartYear}}</th>
                          <th *ngIf="commonService.showControl==true">{{commonService.LastYear}}</th>
                          <th style="text-align:center;">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let items of wizardrowslist.controls;let Pointindex=index;" [formGroupName]="Pointindex">
                          <td>
                            <input class="form-control string caseSenstive" appNumberdirective type="text" maxlength="100" formControlName="ItemDescription" [ngClass]="{ 'is-invalid':(!valid && (wizardrowslist.controls.length > 0) && (wizardrowslist.controls[Pointindex].value['ItemDescription'] == ''))}" />
                            <span class="text-danger" *ngIf="(!valid && (wizardrowslist.controls.length > 0) && (wizardrowslist.controls[Pointindex].value['ItemDescription'] == ''))">Item Description is required</span>
                          </td>
                          <td><input class="form-control text-end AccountNumber" appNumberdirective type="text" formControlName="Total" (change)="CalculationsGrid()" /></td>
                          <td *ngIf="commonService.showControl==true"><input class="form-control text-end AccountNumber" appNumberdirective type="text" formControlName="Total_LY" (change)="CalculationsGrid()" /></td>
                          <td align="center" class="">
                            <button data-toggle="tooltip" data-placement="bottom" title="Delete" class="btn btn-icon   waves-effect waves-light" (click)="deletegridDetails(Pointindex)" [disabled]="disableTurnover">
                              <i class="fa fa-trash-can cantrash text-danger" aria-hidden="true"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                   
                    </table>
                  </div>

                </div>

              </div>
            </div>
            <div class="row text-center mt-2" *ngIf="wizardrowslist?.length<1">
              <b class="mb-2">No records found</b>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4 pe-0" *ngIf="wizardrowslist?.length">
              <div class="d-flex row justify-content-between">
                <div [ngClass]="commonService.showControl? 'col-lg-3 w-293 col-xl-2 col-md-2 col-sm-12 pb-2 text-lg-end text-start':'w-40 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pe-0'"><label class="pt-2">Total</label></div>
                <div [ngClass]="commonService.showControl? 'col-lg-3 w-28 col-xl-4 col-md-4 col-sm-12 pb-2':'w-46  col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'">
                  <div class="input-group">
                    <div class="input-group-text ">£</div>
                    <input type="text" class="form-control text-end AccountNumber" appNumberdirective placeholder="" [disabled]="disableTurnover" value="0" formControlName="Total" />
                  </div>
                </div>
                <div class="col-lg-3 w-293 col-xl-4 col-md-4 col-sm-12 pb-2" *ngIf="commonService.showControl==true">
                  <div class="input-group">
                    <div class="input-group-text ">£</div>
                    <input type="text" class="form-control text-end AccountNumber" appNumberdirective placeholder="" [disabled]="disableTurnover" value="0" formControlName="Total_LY" />
                  </div>
                </div>
                <div  [ngClass]="commonService.showControl ? 'col-lg-3 w-13  col-xl-2 col-md-2 text-end':' w-17'">
                  <!--<button type="button" class="btn themedefault p-1 ps-2 pe-2" (click)="Addnewrow()">Add New</button>-->
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
              <label class="color-black">
                Please enter any additional information in the field below.
              </label>
              <div class="mb-3">
                <textarea class="form-control txt-area string" appNumberdirective [appTooltip]="showBubbledata" maxlength="4000" formControlName="TurnoverRevenueFreeøtextComment" rows="6"></textarea>
              </div>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="Save()">Next</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
